import { Collapse, Form, Input, Button, message } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useAuth } from "../../../../uiComponent/authProvider/AuthContext";
import { OutletSearchRequest } from "../../../../services/dto/outlet";
import { Action } from "../../../../common/enum";
import { SearchMachineContent } from "../../../../services/dto/machine";
import MachineService, {
  MachineServiceAction,
} from "../../../../services/machineService";
import SelectInput from "../../../../uiComponent/input/SelectInput";
import { endpoints } from "../../../../services/endpoints/endpoints";

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 14 },
  },
};

const { Panel } = Collapse;

interface SearchFilterProps {
  setData: React.Dispatch<React.SetStateAction<SearchMachineContent[]>>;
  initSearch?: boolean;
}

export default function SearchFilter({
  initSearch,
  setData,
}: SearchFilterProps) {
  const [form] = Form.useForm();
  const [initSearchFlag, setInitSearchFlag] = useState<boolean>(
    initSearch || false
  );
  const [filterName, setFilterName] = useState("");
  const [loading, setLoading] = useState(false);
  const { loginData } = useAuth();

  const onSearch = useCallback(
    async (values?: any) => {
      if (!loginData?._csrf) {
        return;
      }
      setLoading(true);
      try {
        const request: OutletSearchRequest = {
          code: values?.outlet?.value || "",
          name: values?.name || "",
          action: Action.DETAIL,
          loginId: loginData?.loginUsername || "",
        };

        const response = await MachineService(
          MachineServiceAction.SEARCH,
          request,
          loginData?._csrf
        );
        const data = await response;
        if (data?.result) {
          setData(data.result);
        } else {
          setData([]);
        }
      } catch (error) {
        message.error("Failed to fetch data. Please try again.");
      } finally {
        setLoading(false);
      }
    },
    [setData, loginData]
  );

  useEffect(() => {
    if (initSearchFlag === true) {
      onSearch();
      setInitSearchFlag(false);
    }
  }, [initSearchFlag, setInitSearchFlag, onSearch]);

  const onClean = () => {
    form.resetFields();
    setData([]);
  };

  return (
    <Collapse defaultActiveKey={"1"}>
      <Panel header={"Filter"} key={"1"}>
        <Form
          form={form}
          layout="horizontal"
          labelAlign={"left"}
          onFinish={onSearch}
          style={{ maxWidth: 600 }}
          {...formItemLayout}
        >
          <SelectInput
            label={"Outlet"}
            name={"outlet"}
            url={endpoints.machine.getOutlet}
            placeHolder={"Pilih Outlet"}
          />
          <Form.Item label="Nama" name="name">
            <Input
              placeholder="Input Nama"
              value={filterName}
              onChange={(e) => setFilterName(e.target.value)}
            />
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 0, span: 24 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "10px",
              }}
            >
              <Button type="primary" htmlType="submit" loading={loading}>
                Search
              </Button>
              <Button onClick={onClean} disabled={loading}>
                Clear
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Panel>
    </Collapse>
  );
}
